const getGuidebooks = state => state.player.guidebooks || [];

export default getGuidebooks;
